module.exports = __webpack_public_path__ + "static/media/36handle.c57f261d.png";